<template>
  <b-overlay
    :show="isLoading"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <b-card no-body>
      <b-card-title>
        <div class="p-2 d-flex justify-content-between">
          <span class="h4">โบนัสไทม์</span>
          <CreateModal
            :game-options="gameOptions"
            :product-options="productOptions"
            @submit="upsertData"
          />
        </div>
      </b-card-title>
      <b-table-simple
        striped
        hover
        responsive
        class="position-relative items-center"
        :per-page="perPage"
        :current-page="currentPage"
        style="min-height: 500px;"
      >
        <b-thead>
          <b-tr>
            <b-th>วันที่</b-th>
            <b-th>Actions</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr v-for="item in data.data">
            <b-td>
              {{ item.created_at | dateFormat }}
            </b-td>
            <b-td>
              <b-dropdown
                id="dropdown-3"
                text="Success"
                size="sm"
                variant="success"
              >
                <template #button-content>
                  <i class="far fa-edit mr-50" /> จัดการ
                </template>
                <b-dropdown-item @click="edit(item)"><i class="fas fa-pencil mr-1 text-info" /> แก้ไข
                </b-dropdown-item>
                <b-dropdown-item @click="deleteData(item._id)"><i class="fas fa-trash mr-1 text-danger" /> ลบ
                </b-dropdown-item>
              </b-dropdown>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
      <EditModal
        :game-options="gameOptions"
        :product-options="productOptions"
        :edit-modal="editModal"
        :form="form"
        @submit="upsertData"
        @setModal="editModal = $event"
      />
    </b-card>
  </b-overlay>
</template>

<script>
// import vSelect from 'vue-select'
// import moment from 'moment-timezone'
import {
  BCardTitle, BIconController, BTableSimple, BThead, BTbody, BTr, BTh, BTd, BOverlay, BDropdownItem, BDropdown, BModal, BCard, BTable, BAvatar, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, VBToggle, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import moment from 'moment-timezone'
import CreateModal from './create-modal.vue'
import EditModal from './edit-modal.vue'

export default {
  components: {
    BCardTitle,
    BIconController,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BOverlay,
    BDropdownItem,
    BDropdown,
    BModal,
    BCard,
    BTable,
    BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BFormCheckbox,
    CreateModal,
    EditModal,
    draggable,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  filters: {
    dateFormat(val) {
      return moment(val).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm')
    },
  },
  data() {
    return {
      UserData: JSON.parse(localStorage.getItem('userData')),
      checked: false,
      depositdata: [],
      DataEditID: '',
      name: '',
      detail: '',
      editModal: false,
      turn: '',
      optionsMember: '',
      isLoading: false,
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      usersList: [],
      datasidebar: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      form: {},
      fields: [
        // { key: 'index', label: 'ลำดับ' },
        { key: 'img', label: 'รูป' },
        { key: 'game_name_th', label: 'ชื่อ(ไทย)' },
        { key: 'game_name', label: 'ชื่อ(อังกฤษ)' },
        // { key: 'turn', label: 'เทิร์น' },

        // { key: 'enable', label: 'เปิด/ปิด' },
        { key: 'actions', label: 'Actions' },
        // { key: 'actions', label: 'Action' },
      ],
      /* eslint-disable global-require */
      items: [],
      addNewDataSidebar: false,
      productOptions: [],
      gameOptions: [],
      data: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    agent() {
      return this.$store.state.app.agent
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    // this.Get_userlist()
    this.getBonusTime()
    this.getProductOptions()
    this.getGames()
  },
  methods: {
    async getBonusTime() {
      this.isLoading = true
      try {
        const { data } = await this.$http.get('/game/bonusTime')

        this.data = data
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    switchEnable(id, data) {
      const obj = {
        id,
        status: data,
      }
      // console.log(obj)
      this.$http
        .post('/promotion/status', obj)
        .then(response => {
          console.log(response.data)
        })
        .catch(error => console.log(error))
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    getUserslist() {
      this.$http
        .get('/users/list')
        .then(response => {
          this.optionsMember = response.data
        })
        .catch(error => console.log(error))
    },
    async getProductOptions() {
      try {
        const { data } = await this.$http.get('/game/getSlotProducts')

        this.productOptions = data
      } catch (error) {
        console.log(error)
      }
    },
    async getGames(e) {
      try {
        const { data } = await this.$http.get('/games/games/PGSOFT')
        this.gameOptions = data
      } catch (error) {
        console.log(error)
      }
    },
    onFiltered(filteredItems) {
      filteredItems.forEach(item => {
        if (item.agent_use) {
          const x = item.agent_use.split(',')
          const check = x.indexOf(this.UserData.agent_id.toString())
          // console.log(check)
          if (check >= 0) {
            // eslint-disable-next-line no-param-reassign
            item.status = true
          } else {
            // eslint-disable-next-line no-param-reassign
            item.status = false
          }
        }
      })
      // for (let i = 0; i < filteredItems.length; i += 1) {
      //   if (filteredItems[i].agent_use) {
      //     const x = filteredItems[i].agent_use.split(',')
      //     const check = x.indexOf(this.UserData.agent_id.toString())
      //     if (check >= 0) {
      //     // eslint-disable-next-line no-param-reassign
      //       filteredItems[i].status = true
      //     } else {
      //     // eslint-disable-next-line no-param-reassign
      //       filteredItems[i].status = false
      //     }
      //   }
      // }
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.items = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getAdmin(addby, index) {
      this.$http
        .get(`/admin/show/${addby}`)
        .then(response => {
          console.log(response.data.name)
          this.depositdata[index].addby = response.data.name
        })
        .catch(error => console.log(error))
    },
    async upsertData(form) {
      this.isLoading = true
      try {
        const { data } = await this.$http.post('/game/upsertBonusTime', form)

        // this.getGames();
        this.getBonusTime()
        // console.log(data);
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    deleteData(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.$http
            .delete(`/game/bonusTime/${id}`)
            .then(response => {
              this.getBonusTime()
              if (response.data) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your file has been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
            .catch(error => console.log(error))
        } else {
          this.$swal('Cancelled', 'not been deleted !', 'error')
        }
      })
    },
    addData() {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.name = ''
      this.detail = ''
      this.turn = ''
      this.toggleDataSidebar(true)
      this.datasidebar = {}
    },
    edit(form) {
      this.form = form
      this.editModal = true
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
  background-color: $product-details-bg;
}
